import Contacts from 'collections/contacts';

export default new Contacts();
